import { Box } from "@mui/material"
import DOMPurify from "dompurify"
import { hasVisibleHtmlContent } from "./share-link-html"

export function ShareLinkIntroduction({ html }) {
    // Strip <style> blocks so pasted-in CSS (e.g. TextEdit's p { margin: 0 }) cannot
    // override the reading layout below
    const sanitizedHtml = DOMPurify.sanitize(html ?? "", { FORBID_TAGS: ["style"] })
    if (!hasVisibleHtmlContent(sanitizedHtml)) return null

    return (
        <Box
            data-cy="share-link-introduction"
            sx={{
                typography: "body2",
                color: "text.primary",
                wordBreak: "break-word",
                "& p": { mt: 0, mb: 1 },
                "& ul, & ol": { mt: 0, mb: 1, pl: 3 },
                "& > :first-of-type": { mt: 0 },
                "& > :last-child": { mb: 0 },
            }}
            dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
        />
    )
}
